import { CSSProperties } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowDownIcon from '~/assets/icons/jsx/arrowDownIcon';
import ArrowUpIcon from '~/assets/icons/jsx/arrowUpIcon';
import classes, { arrowSize, textCustomStyle } from './useStyles';

interface SelectInputProps {
  placeholder: string;
  selected: string;
  icon?: JSX.Element;
  customStyle?: CSSProperties;
  isLongText?: boolean;
  isError?: boolean;
  isOpen?: boolean;
  ariaLabel?: string;
  isArrow?: boolean;
  selectedInputText?: string;
}

const SelectInput = ({
  placeholder,
  selected,
  icon,
  customStyle,
  isLongText,
  isError,
  isOpen,
  ariaLabel,
  isArrow = false,
  selectedInputText = '',
}: SelectInputProps) => {
  return (
    <Box
      sx={() => ({
        ...(!isOpen ? classes.root : classes.isOpenStyle),
        ...(isError && classes.error),
        ...customStyle,
      })}
      // style={customStyle}
    >
      {icon && icon}
      <Typography
        aria-label={selected || ariaLabel || placeholder}
        sx={isLongText ? textCustomStyle : {}}
        tabIndex={-1}
      >
        {(selected && `${selectedInputText} ${selected}`) || placeholder}
      </Typography>
      {isArrow &&
        (isOpen ? (
          <ArrowUpIcon style={arrowSize} />
        ) : (
          <ArrowDownIcon style={arrowSize} />
        ))}
    </Box>
  );
};

export default SelectInput;
